var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('FiltreC')],1),_vm._v(" "),_c('div',{staticClass:"col-md-8"},[_c('ListeAnnoncesC')],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d0c15d4","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContentAnnoncesC.vue
// module id = 46
// module chunks = 0